<!-- 看板 -->
<template>
  <el-row>
    <!-- <el-col :span="6" v-for="(o) in 0" :key="o">
      <el-card class="card" :body-style="{ padding: '0px' }">
        <img src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png"
          https://cmny-test.oss-cn-hangzhou.aliyuncs.com/2024-2-27-1709016248341yingshiyun.jpg
          class="image">
        <div style="padding: 10px;">
          <div class="bottom clearfix">
            <time class="time">{{ currentDate }}</time>
            <el-button type="text" class="button">操作按钮</el-button>
          </div>
        </div>
      </el-card>
    </el-col> -->

    <el-dialog title="视频播放" :visible.sync="playVisible" width="850px" style="margin-top: -11vh;" @close="handleClose"
      center class="playDialog">
      <iframe :src="playUrl" width="800" height="600" id="ysOpenDevice" class="showif" allowfullscreen v-if="playUrl">
      </iframe>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePlay">关 闭</el-button>
      </span>
    </el-dialog>
    <el-row>
      <el-col :span="6" class="item" v-for="item in deviceList" :key="item.id">
        <img class="holdiv" :src="item.picUrl" />
        <div class="playdiv">
          <img src="@/assets/common/playCircle.png" @click="playvideo(item)" class="playiv" />
          <p class="tvp">{{ item.channelName }}</p>
        </div>
      </el-col>
    </el-row>
    <img v-if="deviceList.length == 0" src="@/assets/common/poster.png" class="centeriv" />
  </el-row>
</template>
<script>
export default {
  data() {
    return {
      deviceList: [],
      playUrl: '',
      accessToken: '',
      playVisible: false,
      currentDate: new Date()
    };
  },
  methods: {

    playvideo(item) {
      console.log(item);
      if (!this.playVisible) {
        this.playVisible = true;
        this.playUrl = item.url;
      }
    },
    // 关闭播放弹窗
    closePlay() {
      this.playVisible = false;
    },
    // 播放关闭回调
    handleClose() {
      this.playUrl = "";
    },
    closeVideo() {
      this.playUrl = '';
      this.playVisible = false;
    },
    getAllCamera() {
      let param = {
        pageNum: 1,
        pageSize: 10
      };
      console.log(param);
      let channeList = [];
      this.loading = true;
      this.$postJson("dmc/yingShiCamera/queryListWithPage", param).then(
        res => {
          console.log(res);
          res.result.list.forEach(item => {
            if (item.status == 1) {
              //摄像头在线 查找通道
              let param2 = {
                pageNum: 1,
                pageSize: 10,
                deviceId: item.id,
                deviceSerial: item.deviceSerial
              };
              console.log(param2);
              this.$postJson("dmc/yingShiChannel/queryListWithPage", param2).then(res2 => {
                console.log(res2);
                res2.result.list.forEach(item2 => {
                  let params3 = {
                    deviceSerial: item2.deviceSerial,
                    channelNo: item2.channelNo,
                    channelName: item2.channelName,
                    picUrl: item2.picUrl
                  };
                  this.$postJson("dmc/yingShiChannel/getPlayUrl", params3).then((res3) => {
                    let play = res3.result;
                    if (res3.result != null && res3.result.accessToken != null) {
                      let videoUrl = `https://open.ys7.com/ezopen/h5/iframe?url=${play.url}&autoplay=1&audio=1&accessToken=${play.accessToken}`;
                      if (channeList.length < 4) {
                        if(params3.picUrl == 'https://statics.ys7.com/device/assets/imgs/public/homeDevice.jpeg'){
                          params3.picUrl = 'https://cmny-test.oss-cn-hangzhou.aliyuncs.com/2024-2-27-1709016248341yingshiyun.jpg';
                        }
                        this.deviceList.push({
                          url: videoUrl,
                          deviceSerial: params3.deviceSerial,
                          picUrl: params3.picUrl,
                          channelName: params3.channelName
                        })
                        console.log(this.deviceList);
                      }
                    }
                  });

                })
              })
            }
          })
        }
      )
    }
  },
  mounted() {
    this.getAllCamera();
  }
}
</script>
  
<style scoped>
.grid {
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  padding: 3px;
  margin: 0px;
  grid-gap: 1px;
}

.showVideo {
  position: absolute;
  z-index: 999;
  margin: 0 auto;
  margin-left: 20vh;
  min-width: 1200px;
  margin-top: -10px;
  height: 90vh;

  img {
    position: absolute;
    width: 32px;
    height: 32px;
    margin-right: 5px;
    margin-top: 5px;
    margin-left: calc(100% - 35px);
    z-index: 888;
  }
}
.showif{
  margin-top: -20px;
  margin-bottom: -30px;
}
.item {
  padding: 5px;
  height: 280px;

  .holdiv {
    height: 100%;
    width: 100%;
    margin: 0px;
  }

  .playdiv {
    margin: 0px;
    text-align: center;
    position: relative;
    margin-top: -200px;
    height: 200px;
    color: white;
    font-size: 12px;
  }

  .playiv {
    height: 60px;
    margin-top: 40px;
    width: 60px;
  }

  .tvp {
    margin: 0px;
    text-align: center;
    position: relative;
    line-height: 13px;
    margin-top: 40px;
    color: #12d2ac;
    font-size: 18px;
  }
}
</style>